"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderPricePreviewDataHandlers = void 0;
exports.getTermExtensionText = getTermExtensionText;
var aov_helper_const_1 = require("@src/const/aov-helper.const");
var input_output_helper_const_1 = require("@src/const/input-output-helper.const");
var input_mapping_const_1 = require("@src/const/input.mapping.const");
var inter_communication_service_1 = require("@src/services/inter-communication.service");
var object_service_1 = require("@src/services/object-service");
var settings_service_1 = require("@src/services/settings.service");
var translation_1 = __importDefault(require("@src/services/translation"));
var voucher_code_const_1 = require("../membership-completion/voucher-code.const");
var time_mapping_const_1 = require("@src/modules/shared/validation/time-mapping.const");
var RenderPricePreviewDataHandlers = /** @class */ (function () {
    function RenderPricePreviewDataHandlers() {
        var _this = this;
        this.communicationService = object_service_1.ObjectService.getInstance(inter_communication_service_1.InterCommunicationService);
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.discount = 0;
        this.discountType = '?';
        this.credit = 0;
        this.creditLeft = 0;
        this.membershipCreditAdjustment = 0;
        this.membershipCreditAdjustmentRuleText = '';
        this.initDone = false;
        this.offerings = [];
        this.totalModulePrice = 0;
        this.totalOnetimeModulePrice = 0;
        this.totalModuleOriginalPrice = 0;
        this.totalFeePrice = 0;
        this.preUseFee = 0;
        this.calcMembershipPriceBase = function (input) {
            var _a, _b, _c, _d;
            var multiplier = (_c = (_b = (_a = _this.config.get) === null || _a === void 0 ? void 0 : _a.pricePreview) === null || _b === void 0 ? void 0 : _b.paymentFrequencyMultipliers) === null || _c === void 0 ? void 0 : _c[(_d = input.id) === null || _d === void 0 ? void 0 : _d.toString()];
            var price = input.price;
            if (_this.discountType === 'PERCENTAGE') {
                price *= 1 - _this.discount / 100;
            }
            else {
                price -= _this.discount;
            }
            if (multiplier) {
                price *= multiplier;
            }
            return price;
        };
        this.calcMembershipOriginalPrice = function (input) {
            var _a, _b, _c, _d;
            var multiplier = (_c = (_b = (_a = _this.config.get) === null || _a === void 0 ? void 0 : _a.pricePreview) === null || _b === void 0 ? void 0 : _b.paymentFrequencyMultipliers) === null || _c === void 0 ? void 0 : _c[(_d = input.id) === null || _d === void 0 ? void 0 : _d.toString()];
            var price = input.price;
            if (multiplier) {
                price *= multiplier;
            }
            return price;
        };
        this.calcMembershipPrice = function (input) {
            var _a;
            var base = _this.calcMembershipPriceBase(input);
            return Math.max(0, base - ((_a = _this.membershipCreditAdjustment) !== null && _a !== void 0 ? _a : 0));
        };
    }
    RenderPricePreviewDataHandlers.prototype.getUnitInMonths = function (unit) {
        switch (unit) {
            case 'WEEK':
                return 1 / 4;
            case 'MONTH':
                return 1;
            case 'YEAR':
                return 12;
            default:
                return undefined;
        }
    };
    RenderPricePreviewDataHandlers.prototype.getPaymentCountForTerm = function (term) {
        var termUnitInMonths = this.getUnitInMonths(term.termUnit);
        var paymentUnitInMonths = this.getUnitInMonths(term.paymentFrequencyUnit);
        if (!termUnitInMonths ||
            !paymentUnitInMonths ||
            !term.termValue ||
            !term.paymentFrequencyValue ||
            term.paymentFrequencyType === 'NON_RECURRING' ||
            term.paymentFrequencyType === 'FREE' ||
            term.paymentFrequencyType === 'TERM_BASED') {
            return 1;
        }
        var totalTermMonths = term.termValue * termUnitInMonths;
        var paymentIntervalMonths = term.paymentFrequencyValue * paymentUnitInMonths;
        if (paymentIntervalMonths <= 0)
            return 1;
        return Math.max(1, Math.floor(totalTermMonths / paymentIntervalMonths));
    };
    RenderPricePreviewDataHandlers.prototype.initModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                if (!this.module) {
                    console.warn('Price preview data handler module not initialized, not rendering data handlers');
                    return [2 /*return*/];
                }
                // voucher validation on click on button
                if ((_a = this.module.references.validateVoucher) === null || _a === void 0 ? void 0 : _a.domElement) {
                    this.module.references.validateVoucher.domElement.on('click', function (event) { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    event.preventDefault();
                                    return [4 /*yield*/, this.updateDataHandlers()];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                }
                // listen to membership selection in case price preview is on same page as the selection
                // this.communicationService.subscribeGlobally().subscribe(async (data) => {
                //   console.log('render price preview datahandler got event', data);
                //   if (data.module?.moduleKey === 'membership-selection' && data.event === 'custom' && data.name === 'membershipSelected') {
                //     this.updateSelectedOffering();
                //     await this.updateDataHandlers();
                //   }
                // });
                this.communicationService.subscribeGlobally().subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                    var validationResult;
                    return __generator(this, function (_a) {
                        if (data.event === 'globalCustom' && data.name === 'voucherCodeValidationResult') {
                            validationResult = data.value;
                            this.updateDataHandlers(validationResult);
                        }
                        return [2 /*return*/];
                    });
                }); });
                this.initDone = true;
                return [2 /*return*/];
            });
        });
    };
    RenderPricePreviewDataHandlers.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/];
        }); });
    };
    RenderPricePreviewDataHandlers.prototype.reloadPricePreview = function (offerings, timeMapping, preview) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.initDone) {
                            this.initModule();
                        }
                        this.preview = preview;
                        this.offerings = offerings;
                        this.timeMapping = timeMapping;
                        this.updateSelectedOffering();
                        return [4 /*yield*/, this.updateDataHandlers()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RenderPricePreviewDataHandlers.prototype.updateDataHandlers = function (inputVoucherResult) {
        return __awaiter(this, void 0, void 0, function () {
            var startDate, today, parsedStartDate, startIsInFuture, voucherRes, hasVoucher, voucherPreview, moduleContainer, moduleClones, $template, _loop_1, this_1, _i, _a, paidModuleId, totalDiscountedFeePrice, feeContainer, feeClones, _b, _c, fee, $template, originalFeePrice_1, discountedFeePreview, finalFeePrice_1, clone, originalFeePrice, finalFeePrice, creditUsed, paymentCount, originalMembershipRecurring, value, unit, _d, feeClones_1, feeClone, _e, moduleClones_1, moduleClone, dataHandler, dataHandler, membershipPrice, basePrice, firstPayment, membershipPrice, dataHandler, originalRecurringPrice, finalRecurringPrice;
            var _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16;
            return __generator(this, function (_17) {
                switch (_17.label) {
                    case 0:
                        this.termId = (0, input_output_helper_const_1._ReadFieldFromLocalstorage)(input_mapping_const_1._AllMappings.rateBundleTermId);
                        if (!this.offerings || !this.selectedOffer || !this.selectedTerm) {
                            console.warn('Price preview datahandler found no offer or term, cannot render');
                            return [2 /*return*/];
                        }
                        if (!this.module) {
                            console.warn('Price preview data handler module not initialized, not rendering data handlers');
                            return [2 /*return*/];
                        }
                        startDate = (0, input_output_helper_const_1._ReadFieldFromLocalstorage)(input_mapping_const_1._AllMappings.rateBundleStartDate);
                        today = new Date();
                        today.setHours(0, 0, 0, 0);
                        parsedStartDate = startDate ? new Date(startDate) : null;
                        parsedStartDate === null || parsedStartDate === void 0 ? void 0 : parsedStartDate.setHours(0, 0, 0, 0);
                        startIsInFuture = !!parsedStartDate && parsedStartDate.getTime() > today.getTime();
                        this.preUseFee = (_g = (_f = this.preview) === null || _f === void 0 ? void 0 : _f.preUseCharge) !== null && _g !== void 0 ? _g : 0;
                        console.log('start is in future', startIsInFuture, 'preuse fee', this.preUseFee);
                        voucherRes = inputVoucherResult;
                        if (!!voucherRes) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, voucher_code_const_1._TestVoucherCode)(this.$container)];
                    case 1:
                        voucherRes = _17.sent();
                        _17.label = 2;
                    case 2:
                        console.log('Voucher res', voucherRes);
                        if (((_h = voucherRes.data) === null || _h === void 0 ? void 0 : _h.discount) && ((_j = voucherRes.data) === null || _j === void 0 ? void 0 : _j.discount) > 0) {
                            // disable so they cant change it again, as its read during submit and if the customer changes it, it shows applied but wont work
                            this.$container.find('#' + input_mapping_const_1._AllMappings.voucherCode.uid).prop('disabled', true);
                            this.discount = (_k = voucherRes.data) === null || _k === void 0 ? void 0 : _k.discount;
                            this.discountType = (_l = voucherRes.data) === null || _l === void 0 ? void 0 : _l.discountType;
                            localStorage.setItem(input_mapping_const_1._AllMappings.voucherCode.uid, voucherRes.data.voucherCode);
                        }
                        else {
                            this.discount = 0;
                        }
                        if (((_m = voucherRes === null || voucherRes === void 0 ? void 0 : voucherRes.data) === null || _m === void 0 ? void 0 : _m.creditValue) && ((_p = (_o = this.config.get) === null || _o === void 0 ? void 0 : _o.pricePreview) === null || _p === void 0 ? void 0 : _p.showCreditVouchersAsStrikedPrice) === true) {
                            this.credit = (_q = voucherRes.data) === null || _q === void 0 ? void 0 : _q.creditValue;
                            this.creditLeft = this.credit;
                        }
                        else {
                            this.credit = 0;
                            this.creditLeft = 0;
                            this.membershipCreditAdjustment = 0;
                            this.membershipCreditAdjustmentRuleText = '';
                        }
                        hasVoucher = !!((_s = (_r = voucherRes.data) === null || _r === void 0 ? void 0 : _r.voucherCode) === null || _s === void 0 ? void 0 : _s.length);
                        // remove wrong vouchers from local storage
                        if (voucherRes.valid === false) {
                            localStorage.removeItem(input_mapping_const_1._AllMappings.voucherCode.uid);
                        }
                        // merge the voucher res into the preview for the AOV
                        if (voucherRes.valid === false || !hasVoucher) {
                            this.preview = clearVoucherPreview(this.preview);
                        }
                        else {
                            voucherPreview = {
                                discountValue: (_u = (_t = voucherRes.data) === null || _t === void 0 ? void 0 : _t.discountValue) !== null && _u !== void 0 ? _u : (_v = voucherRes.data) === null || _v === void 0 ? void 0 : _v.discount,
                                discountType: (_w = voucherRes.data) === null || _w === void 0 ? void 0 : _w.discountType,
                                discountedBasePrice: (_x = voucherRes.data) === null || _x === void 0 ? void 0 : _x.discountedBasePrice,
                                discountedPreUseCharge: (_y = voucherRes.data) === null || _y === void 0 ? void 0 : _y.discountedPreUseCharge,
                                creditValue: (_z = voucherRes.data) === null || _z === void 0 ? void 0 : _z.creditValue,
                                effectivePeriodTimeBasedTerm: (_0 = voucherRes.data) === null || _0 === void 0 ? void 0 : _0.effectivePeriodTimeBasedTerm,
                                effectivePeriodTimeBasedTermUnit: (_1 = voucherRes.data) === null || _1 === void 0 ? void 0 : _1.effectivePeriodTimeBasedTermUnit,
                                flatFeePreviews: (_2 = voucherRes.data) === null || _2 === void 0 ? void 0 : _2.flatFeePreviews,
                                selectedOptionalModulesPreviews: (_3 = voucherRes.data) === null || _3 === void 0 ? void 0 : _3.selectedOptionalModulesPreviews,
                            };
                            this.preview = __assign(__assign({}, this.preview), Object.fromEntries(Object.entries(voucherPreview).filter(function (_a) {
                                var value = _a[1];
                                return value !== undefined;
                            })));
                        }
                        (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._AllMappings.rateBundleAOV, JSON.stringify((0, aov_helper_const_1._CalculateAOV_V2)(this.selectedTerm, this.paidModules, this.preview)));
                        // remove clones
                        this.$container.find("[data-clone='true']").remove();
                        // data-ref optional modules
                        this.totalModulePrice = 0;
                        this.totalModuleOriginalPrice = 0;
                        this.totalOnetimeModulePrice = 0;
                        moduleClones = [];
                        if ((_5 = (_4 = this.module.references) === null || _4 === void 0 ? void 0 : _4.optionalModules) === null || _5 === void 0 ? void 0 : _5.domElement) {
                            $template = this.module.references.optionalModules.domElement;
                            moduleContainer = this.module.references.optionalModules.parent;
                            _loop_1 = function (paidModuleId) {
                                var module_1 = this_1.selectedTerm.optionalModules.find(function (opt) { return opt.id === paidModuleId; });
                                if (module_1) {
                                    var multiplier = (_10 = (_8 = (_7 = (_6 = this_1.config.get) === null || _6 === void 0 ? void 0 : _6.pricePreview) === null || _7 === void 0 ? void 0 : _7.paymentFrequencyMultipliers) === null || _8 === void 0 ? void 0 : _8[(_9 = this_1.selectedTerm.id) === null || _9 === void 0 ? void 0 : _9.toString()]) !== null && _10 !== void 0 ? _10 : 1;
                                    var originalModulePrice = module_1.price * multiplier;
                                    var discountedModulePreview = this_1.findDiscountedOptionalModulePreview(module_1, voucherRes);
                                    var finalModulePrice = (discountedModulePreview === null || discountedModulePreview === void 0 ? void 0 : discountedModulePreview.discountedPrice) !== null && (discountedModulePreview === null || discountedModulePreview === void 0 ? void 0 : discountedModulePreview.discountedPrice) !== undefined
                                        ? discountedModulePreview.discountedPrice * multiplier
                                        : originalModulePrice;
                                    // if its not recurring, it still counts as onetime payment
                                    // term based usually means not a onetime payment, which is not supported yet
                                    if (module_1.paymentFrequencyType !== 'TERM_BASED') {
                                        this_1.totalModuleOriginalPrice += originalModulePrice;
                                        this_1.totalModulePrice += finalModulePrice;
                                    }
                                    if (((_11 = module_1.paymentFrequencyDto) === null || _11 === void 0 ? void 0 : _11.type) === 'TERM_BASED' && module_1.paymentFrequencyDto.recurring === false) {
                                        this_1.totalOnetimeModulePrice += finalModulePrice;
                                    }
                                    var clone = $template.clone();
                                    clone.attr('data-clone', 'true');
                                    this_1.setDataHandlerValues(module_1, clone, {
                                        term: this_1.selectedTerm,
                                        discountedPrice: finalModulePrice,
                                        originalPrice: originalModulePrice,
                                    });
                                    moduleClones.push(clone);
                                }
                                else {
                                    console.warn('price preview was given the optional module', paidModuleId, 'but its not included in term', this_1.selectedTerm);
                                }
                            };
                            this_1 = this;
                            for (_i = 0, _a = this.paidModules; _i < _a.length; _i++) {
                                paidModuleId = _a[_i];
                                _loop_1(paidModuleId);
                            }
                        }
                        // fees
                        this.totalFeePrice = 0;
                        totalDiscountedFeePrice = 0;
                        feeClones = [];
                        if ((_12 = this.module.references.fees) === null || _12 === void 0 ? void 0 : _12.domElement) {
                            for (_b = 0, _c = this.selectedTerm.flatFees; _b < _c.length; _b++) {
                                fee = _c[_b];
                                $template = this.module.references.fees.domElement;
                                feeContainer = this.module.references.fees.parent;
                                originalFeePrice_1 = fee.price;
                                discountedFeePreview = this.findDiscountedFlatFeePreview(fee, voucherRes);
                                finalFeePrice_1 = (discountedFeePreview === null || discountedFeePreview === void 0 ? void 0 : discountedFeePreview.discountedPrice) !== null && (discountedFeePreview === null || discountedFeePreview === void 0 ? void 0 : discountedFeePreview.discountedPrice) !== undefined
                                    ? discountedFeePreview.discountedPrice
                                    : originalFeePrice_1;
                                clone = $template.clone();
                                clone.attr('data-clone', 'true');
                                this.setDataHandlerValues(fee, clone, {
                                    discountedPrice: finalFeePrice_1,
                                    originalPrice: originalFeePrice_1,
                                });
                                feeClones.push(clone);
                                this.totalFeePrice += originalFeePrice_1;
                                totalDiscountedFeePrice += finalFeePrice_1;
                            }
                        }
                        originalFeePrice = this.totalFeePrice;
                        finalFeePrice = totalDiscountedFeePrice;
                        if (this.creditLeft > 0 && originalFeePrice > 0) {
                            creditUsed = Math.min(this.creditLeft, originalFeePrice);
                            finalFeePrice = originalFeePrice - creditUsed;
                            this.creditLeft = this.creditLeft - creditUsed;
                        }
                        if (this.creditLeft > 0) {
                            paymentCount = this.getPaymentCountForTerm(this.selectedTerm);
                            this.membershipCreditAdjustment = this.creditLeft / paymentCount;
                            originalMembershipRecurring = this.calcMembershipPriceBase(this.selectedTerm);
                            value = ((_13 = this.selectedTerm.termValue) !== null && _13 !== void 0 ? _13 : 0) + 1;
                            unit = translation_1.default.t(this.selectedTerm.termUnit);
                            this.membershipCreditAdjustmentRuleText = translation_1.default.t('creditMembershipAdjustmentRule', {
                                newPrice: originalMembershipRecurring.toFixed(2),
                                value: value,
                                unit: unit,
                                article: translation_1.default.t(this.selectedTerm.termUnit === 'WEEK' ? 'week_article_dative' : 'month_article_dative'),
                            });
                            this.creditLeft = 0;
                        }
                        else {
                            this.membershipCreditAdjustment = 0;
                            this.membershipCreditAdjustmentRuleText = '';
                        }
                        // basic data-get for each attribut of an offering and term, will overwrite handlers exiting for both (like id)
                        this.setDataHandlerValues(this.selectedOffer, this.$container);
                        this.setDataHandlerValues(this.selectedTerm, this.$container, { term: this.selectedTerm });
                        // append modules etc last, so their data-gets arent overwritten by the above setDataHandlerValues
                        if (feeContainer && (feeClones === null || feeClones === void 0 ? void 0 : feeClones.length)) {
                            for (_d = 0, feeClones_1 = feeClones; _d < feeClones_1.length; _d++) {
                                feeClone = feeClones_1[_d];
                                feeContainer.append(feeClone);
                            }
                        }
                        if (moduleContainer && (moduleClones === null || moduleClones === void 0 ? void 0 : moduleClones.length)) {
                            for (_e = 0, moduleClones_1 = moduleClones; _e < moduleClones_1.length; _e++) {
                                moduleClone = moduleClones_1[_e];
                                moduleContainer.append(moduleClone);
                            }
                        }
                        // render total fee price = AFTER credit
                        if (this.$container.find("[data-get='totalFeePrice']").length) {
                            this.$container.find("[data-get='totalFeePrice']").html(finalFeePrice.toFixed(2));
                        }
                        // render original fee price = BEFORE credit / vouchers
                        if (this.$container.find("[data-get='totalFeeOriginalPrice']").length) {
                            dataHandler = this.$container.find("[data-get='totalFeeOriginalPrice']");
                            dataHandler.css('display', originalFeePrice !== finalFeePrice ? 'block' : 'none');
                            dataHandler.html(originalFeePrice.toFixed(2));
                        }
                        if (this.$container.find("[data-get='totalModulePrice']").length) {
                            this.$container.find("[data-get='totalModulePrice']").html(this.totalModulePrice.toFixed(2));
                        }
                        if (this.$container.find("[data-get='totalModuleOriginalPrice']").length) {
                            dataHandler = this.$container.find("[data-get='totalModuleOriginalPrice']");
                            dataHandler.css('display', this.totalModuleOriginalPrice !== this.totalModulePrice ? 'block' : 'none');
                            dataHandler.html(this.totalModuleOriginalPrice.toFixed(2));
                        }
                        // total first payment
                        if (this.$container.find("[data-get='firstPayment']").length) {
                            membershipPrice = this.calcMembershipPrice(this.selectedTerm);
                            basePrice = this.preUseFee + finalFeePrice + this.totalModulePrice + this.totalOnetimeModulePrice;
                            if (!startIsInFuture) {
                                basePrice += membershipPrice;
                            }
                            firstPayment = typeof ((_14 = this.preview) === null || _14 === void 0 ? void 0 : _14.dueToday) === 'number' ? this.preview.dueToday : basePrice;
                            this.$container.find("[data-get='firstPayment']").html(firstPayment.toFixed(2));
                        }
                        // total recurring payment
                        if (this.$container.find("[data-get='totalRecurringPrice']").length) {
                            membershipPrice = this.calcMembershipPrice(this.selectedTerm);
                            this.$container.find("[data-get='totalRecurringPrice']").html((membershipPrice + this.totalModulePrice).toFixed(2));
                        }
                        if (this.$container.find("[data-get='totalRecurringOriginalPrice']").length) {
                            dataHandler = this.$container.find("[data-get='totalRecurringOriginalPrice']");
                            originalRecurringPrice = this.calcMembershipOriginalPrice(this.selectedTerm) + ((_15 = this.totalModuleOriginalPrice) !== null && _15 !== void 0 ? _15 : 0);
                            finalRecurringPrice = this.calcMembershipPrice(this.selectedTerm) + ((_16 = this.totalModulePrice) !== null && _16 !== void 0 ? _16 : 0);
                            dataHandler.css('display', originalRecurringPrice !== finalRecurringPrice ? 'block' : 'none');
                            dataHandler.html(originalRecurringPrice.toFixed(2));
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    RenderPricePreviewDataHandlers.prototype.updateSelectedOffering = function () {
        var _this = this;
        if (this.offerings) {
            this.termId = (0, input_output_helper_const_1._ReadFieldFromLocalstorage)(input_mapping_const_1._AllMappings.rateBundleTermId);
            this.freeModules = JSON.parse(localStorage.getItem('selectableModules') || '[]');
            this.paidModules = JSON.parse(localStorage.getItem('optionalModules') || '[]');
            for (var _i = 0, _a = this.offerings; _i < _a.length; _i++) {
                var offer = _a[_i];
                var term = offer.terms.find(function (a) { return String(a.id) === String(_this.termId); });
                if (term && offer) {
                    this.selectedTerm = term;
                    this.selectedOffer = offer;
                    console.log('found selected term', term, offer);
                    return true;
                }
            }
        }
    };
    /**
     * Takes an object and a container, checks for data-get for each key of the object inside the container and replaces its content
     * @param input
     * @param container
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    RenderPricePreviewDataHandlers.prototype.setDataHandlerValues = function (input, container, data) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32;
        for (var _i = 0, _33 = Object.keys(input); _i < _33.length; _i++) {
            var key = _33[_i];
            var keyType = typeof input[key];
            var dataHandler = container.find("[data-get='".concat(key, "']"));
            if (keyType === 'string' || keyType === 'number' || keyType === 'boolean') {
                // price, but not term price. modules, fees, etc
                if (key === 'price' && dataHandler.length) {
                    var multiplier = (_f = (_c = (_b = (_a = this.config.get) === null || _a === void 0 ? void 0 : _a.pricePreview) === null || _b === void 0 ? void 0 : _b.paymentFrequencyMultipliers) === null || _c === void 0 ? void 0 : _c[(_e = (_d = data === null || data === void 0 ? void 0 : data.term) === null || _d === void 0 ? void 0 : _d.id) === null || _e === void 0 ? void 0 : _e.toString()]) !== null && _f !== void 0 ? _f : 1;
                    var price = (_g = data === null || data === void 0 ? void 0 : data.discountedPrice) !== null && _g !== void 0 ? _g : input[key] * multiplier;
                    dataHandler.html(price.toFixed(2));
                }
                else if (key === 'name') {
                    if (!isTerm(input)) {
                        dataHandler.html(input.name); // name is offering name not term name
                    }
                }
                else if (dataHandler.length) {
                    //console.log('basic formatting for value', input[key]);
                    dataHandler.html(translation_1.default.t(input[key].toString()));
                }
            }
        }
        if ((isOptionalModule(input) || isFlatfee(input)) && (data === null || data === void 0 ? void 0 : data.originalPrice) !== undefined) {
            var hasDiscount = data.discountedPrice !== undefined && data.discountedPrice !== data.originalPrice;
            if (container.find("[data-get='originalPrice']").length) {
                var dataHandler = container.find("[data-get='originalPrice']");
                dataHandler.css('display', hasDiscount ? 'block' : 'none');
                dataHandler.html(data.originalPrice.toFixed(2));
            }
        }
        // stupid exceptions, combine term etc to one translated combination
        // make sure this is last, so it overwrites if the key actually exist on some object
        if (isTerm(input) && (data === null || data === void 0 ? void 0 : data.term)) {
            // data handlers only for the term (outside a module ref container)
            if (container.find("[data-get='price']").length && (this.discount > 0 || this.membershipCreditAdjustment > 0)) {
                var dataHandler = container.find("[data-get='price']");
                var price = this.calcMembershipPrice(input);
                dataHandler.html(price.toFixed(2)); // term price, considering voucher discount
            }
            if (container.find("[data-get='originalPrice']").length) {
                var dataHandler = container.find("[data-get='originalPrice']");
                dataHandler.css('display', this.discount > 0 || this.membershipCreditAdjustment > 0 ? 'block' : 'none');
                dataHandler.html(this.calcMembershipOriginalPrice(input).toFixed(2));
            }
            if (container.find("[data-get='term']").length) {
                container.find("[data-get='term']").html(this.formatValueWithUnit(input.termValue, input.termUnit, false)); // term duration (e.g. 12 MONATE)
            }
            if (container.find("[data-get='contractTotalValue']").length && data.term) {
                var aov = (0, aov_helper_const_1._CalculateAOV_V2)(data.term, this.paidModules, this.preview);
                container.find("[data-get='contractTotalValue']").html(aov.total.toFixed(2));
            }
            if (container.find("[data-get='contractTotalMembership']").length && data.term) {
                var aov = (0, aov_helper_const_1._CalculateAOV_V2)(data.term, this.paidModules, this.preview);
                container.find("[data-get='contractTotalMembership']").html(aov.subscription.toFixed(2));
            }
            if (container.find("[data-get='contractTotalFees']").length && data.term) {
                var aov = (0, aov_helper_const_1._CalculateAOV_V2)(data.term, this.paidModules, this.preview);
                container.find("[data-get='contractTotalFees']").html(aov.fees.toFixed(2));
            }
            if (container.find("[data-get='contractTotalModules']").length && data.term) {
                var aov = (0, aov_helper_const_1._CalculateAOV_V2)(data.term, this.paidModules, this.preview);
                container.find("[data-get='contractTotalModules']").html(aov.modules.toFixed(2));
            }
            if (container.find("[data-get='cancellation']").length) {
                var newVal = this.formatValueWithUnit(input.cancellationPeriod, input.cancellationPeriodUnit, false);
                container.find("[data-get='cancellation']").html(newVal.length ? newVal : 'Keine');
            }
            if (container.find("[data-get='bonusPeriod']").length) {
                var newVal = this.formatValueWithUnit(input.termValue - input.termValueWithoutBonusPeriod, input.termUnit, false);
                container.find("[data-get='bonusPeriod']").html(newVal);
            }
            if (container.find("[data-get='bonusPeriodText']").length) {
                var newVal = this.formatValueWithUnit(input.termValue - input.termValueWithoutBonusPeriod, input.termUnit, false);
                if (newVal.length) {
                    newVal = translation_1.default.t('bonus period') + ': ' + newVal;
                }
                container.find("[data-get='bonusPeriodText']").html(newVal);
            }
            if (container.find("[data-get='adjustmentRules']").length) {
                var parts = __spreadArray(__spreadArray([], ((_k = (_j = (_h = data.term) === null || _h === void 0 ? void 0 : _h.priceAdjustmentRules) === null || _j === void 0 ? void 0 : _j.map(function (a) { return a.defaultDescription; })) !== null && _k !== void 0 ? _k : []), true), [
                    this.membershipCreditAdjustmentRuleText,
                ], false).filter(Boolean);
                container.find("[data-get='adjustmentRules']").html(parts.join('.<br>'));
            }
            if (container.find("[data-get='contractStartDate']").length) {
                var newVal = data.term.defaultContractStartDate;
                container.find("[data-get='contractStartDate']").html(newVal);
            }
            if (container.find("[data-get='contractStartDateOfUse']").length) {
                var newVal = data.term.contractStartDateOfUse;
                container.find("[data-get='contractStartDateOfUse']").html(newVal);
            }
            // NOTE: extension depends on extensionType and can be SUBSEQUENT_RATE_DETAIL (use subsequentRateDto) OR TERM_EXTENSION (use extensionTerm)
            // extensionFrequency -> how long you have to cancel after the extension starts (as unit, like monthly, weekly)
            if (container.find("[data-get='extensionFrequency']").length) {
                var newVal = '';
                if (data.term.extensionType === 'TERM_EXTENSION') {
                    newVal = this.formatValueWithUnit(data.term.extensionFixedTerm, data.term.extensionCancellationPeriodUnit, true);
                }
                else if (data.term.extensionType === 'SUBSEQUENT_RATE_DETAIL') {
                    newVal = this.formatValueWithUnit((_o = (_m = (_l = data.term.subsequentRateDto) === null || _l === void 0 ? void 0 : _l.terms) === null || _m === void 0 ? void 0 : _m[0]) === null || _o === void 0 ? void 0 : _o.termValue, (_r = (_q = (_p = data.term.subsequentRateDto) === null || _p === void 0 ? void 0 : _p.terms) === null || _q === void 0 ? void 0 : _q[0]) === null || _r === void 0 ? void 0 : _r.termUnit, true);
                }
                container.find("[data-get='extensionFrequency']").html(newVal);
            }
            // subsequentPrice -> how much does it cost after extension
            if (container.find("[data-get='subsequentPrice']").length) {
                var newVal = '';
                if (data.term.extensionType === 'TERM_EXTENSION') {
                    var adjustmentRuleEval = adjustmentRuleIsAfterTerm(data.term);
                    if (adjustmentRuleEval.isAfterTerm) {
                        newVal = adjustmentRuleEval.newPrice.toFixed(2);
                    }
                    else {
                        newVal = data.term.price.toFixed(2);
                    }
                }
                else if (data.term.extensionType === 'SUBSEQUENT_RATE_DETAIL') {
                    newVal = ((_v = (_u = (_t = (_s = data.term.subsequentRateDto) === null || _s === void 0 ? void 0 : _s.terms) === null || _t === void 0 ? void 0 : _t[0]) === null || _u === void 0 ? void 0 : _u.price) === null || _v === void 0 ? void 0 : _v.toFixed(2)) || '';
                }
                container.find("[data-get='subsequentPrice']").html(newVal);
            }
            // subsequentFrequency -> how often do you pay (monthly, weekly)
            if (container.find("[data-get='subsequentFrequency']").length) {
                var newVal = '';
                if (data.term.extensionType === 'TERM_EXTENSION') {
                    newVal = this.formatValueWithUnit(data.term.paymentFrequencyValue, data.term.paymentFrequencyUnit, true);
                }
                else if (data.term.extensionType === 'SUBSEQUENT_RATE_DETAIL') {
                    newVal = this.formatValueWithUnit((_y = (_x = (_w = data.term.subsequentRateDto) === null || _w === void 0 ? void 0 : _w.terms) === null || _x === void 0 ? void 0 : _x[0]) === null || _y === void 0 ? void 0 : _y.paymentFrequencyValue, (_1 = (_0 = (_z = data.term.subsequentRateDto) === null || _z === void 0 ? void 0 : _z.terms) === null || _0 === void 0 ? void 0 : _0[0]) === null || _1 === void 0 ? void 0 : _1.paymentFrequencyUnit, true);
                }
                container.find("[data-get='subsequentFrequency']").html(newVal);
            }
            // subsequentDuration -> how often do you pay as frequency (monthly, weekly, etc)
            if (container.find("[data-get='subsequentDuration']").length) {
                var newVal = '';
                if (data.term.extensionType === 'TERM_EXTENSION') {
                    newVal = this.formatValueWithUnit(data.term.paymentFrequencyValue, data.term.paymentFrequencyUnit, true);
                }
                else if (data.term.extensionType === 'SUBSEQUENT_RATE_DETAIL') {
                    newVal = this.formatValueWithUnit((_4 = (_3 = (_2 = data.term.subsequentRateDto) === null || _2 === void 0 ? void 0 : _2.terms) === null || _3 === void 0 ? void 0 : _3[0]) === null || _4 === void 0 ? void 0 : _4.paymentFrequencyValue, (_7 = (_6 = (_5 = data.term.subsequentRateDto) === null || _5 === void 0 ? void 0 : _5.terms) === null || _6 === void 0 ? void 0 : _6[0]) === null || _7 === void 0 ? void 0 : _7.paymentFrequencyUnit, true);
                }
                else if (data.term.extensionType === 'NONE') {
                    newVal = 'Keine';
                }
                container.find("[data-get='subsequentDuration']").html(newVal);
            }
            // subsequentDuration -> how often do you pay as unit (Month, Week)
            if (container.find("[data-get='subsequentDurationUnit']").length) {
                var newVal = '';
                if (data.term.extensionType === 'TERM_EXTENSION') {
                    newVal = this.formatValueWithUnit(data.term.paymentFrequencyValue, data.term.paymentFrequencyUnit, false);
                }
                else if (data.term.extensionType === 'SUBSEQUENT_RATE_DETAIL') {
                    newVal = this.formatValueWithUnit((_10 = (_9 = (_8 = data.term.subsequentRateDto) === null || _8 === void 0 ? void 0 : _8.terms) === null || _9 === void 0 ? void 0 : _9[0]) === null || _10 === void 0 ? void 0 : _10.paymentFrequencyValue, (_13 = (_12 = (_11 = data.term.subsequentRateDto) === null || _11 === void 0 ? void 0 : _11.terms) === null || _12 === void 0 ? void 0 : _12[0]) === null || _13 === void 0 ? void 0 : _13.paymentFrequencyUnit, false);
                }
                else if (data.term.extensionType === 'NONE') {
                    newVal = 'Keine';
                }
                container.find("[data-get='subsequentDurationUnit']").html(newVal);
            }
            if (container.find("[data-get='subsequentDurationText']").length) {
                var newVal = getTermExtensionText(data.term);
                container.find("[data-get='subsequentDurationText']").html(newVal);
            }
            // subsequent term as formatted text
            if (container.find("[data-get='subsequentTerm']").length) {
                if ((_15 = (_14 = data.term.subsequentRateDto) === null || _14 === void 0 ? void 0 : _14.terms) === null || _15 === void 0 ? void 0 : _15.length) {
                    var subsequentFrequency = this.formatValueWithUnit((_18 = (_17 = (_16 = data.term.subsequentRateDto) === null || _16 === void 0 ? void 0 : _16.terms) === null || _17 === void 0 ? void 0 : _17[0]) === null || _18 === void 0 ? void 0 : _18.paymentFrequencyValue, (_21 = (_20 = (_19 = data.term.subsequentRateDto) === null || _19 === void 0 ? void 0 : _19.terms) === null || _20 === void 0 ? void 0 : _20[0]) === null || _21 === void 0 ? void 0 : _21.paymentFrequencyUnit, true);
                    var subsequentPrice = ((_23 = (_22 = data.term.subsequentRateDto.terms[0]) === null || _22 === void 0 ? void 0 : _22.price) === null || _23 === void 0 ? void 0 : _23.toFixed(2)) || '';
                    var cancellationFrequency = this.formatValueWithUnit(data.term.cancellationPeriod, data.term.cancellationPeriodUnit, true);
                    var cancellationDuration = this.formatValueWithUnit(data.term.cancellationPeriod, data.term.cancellationPeriodUnit, false);
                    var minimumTerm = this.formatValueWithUnit(input.termValue, input.termUnit, false);
                    var text = "\n            Mindestlaufzeit ".concat(minimumTerm, ". \n            Wenn nicht ").concat(cancellationDuration, " vor Ablauf der Mindestlaufzeit gek\u00FCndigt wird, \n            wird deine Mitgliedschaft automatisch als ").concat(cancellationFrequency, " k\u00FCndbare Mitgliedschaft \n            zu je ").concat(subsequentFrequency, " ").concat(subsequentPrice, "\u20AC weitergef\u00FChrt.");
                    container.find("[data-get='subsequentTerm']").html(text);
                }
            }
            // cost of the preuse, if any
            if (container.find("[data-get='preUseCharge']").length) {
                var newVal = ((_25 = (_24 = this.preview) === null || _24 === void 0 ? void 0 : _24.preUseCharge) !== null && _25 !== void 0 ? _25 : 0).toFixed(2);
                container.find("[data-get='preUseCharge']").html(newVal);
            }
            // timeframe of the preuse, basically what timeframe the preuse charge is for
            if (container.find("[data-get='preUseTimeframe']").length) {
                var start = data.term.contractStartDateOfUse;
                var end = data.term.defaultContractStartDate;
                var newVal = '-';
                if (((_26 = this.preview) === null || _26 === void 0 ? void 0 : _26.preUseCharge) && ((_27 = this.selectedOffer) === null || _27 === void 0 ? void 0 : _27.preuseType) === 'CHARGEABLE') {
                    newVal = start === end ? start : start + ' - ' + end;
                }
                container.find("[data-get='preUseTimeframe']").html(newVal);
            }
        }
        if (isOptionalModule(input) || isTerm(input) || isFlatfee(input)) {
            // data handlers for term and modules and fees
            if (container.find("[data-get='paymentFrequency']").length) {
                if (input.paymentFrequencyType === 'TERM_BASED') {
                    container.find("[data-get='paymentFrequency']").html(translation_1.default.t('Term'));
                }
                else if (input.paymentFrequencyType === 'FREE') {
                    container.find("[data-get='paymentFrequency']").html(translation_1.default.t('free'));
                }
                else if (input.paymentFrequencyType === 'NON_RECURRING') {
                    container.find("[data-get='paymentFrequency']").html(translation_1.default.t('once'));
                }
                else if (typeof input.paymentFrequencyValue === 'number') {
                    var multiplier = (_32 = (_30 = (_29 = (_28 = this.config.get) === null || _28 === void 0 ? void 0 : _28.pricePreview) === null || _29 === void 0 ? void 0 : _29.paymentFrequencyMultipliers) === null || _30 === void 0 ? void 0 : _30[(_31 = data === null || data === void 0 ? void 0 : data.term) === null || _31 === void 0 ? void 0 : _31.id]) !== null && _32 !== void 0 ? _32 : 1;
                    var newVal = this.formatValueWithUnit(input.paymentFrequencyValue * multiplier, input.paymentFrequencyUnit, true);
                    container.find("[data-get='paymentFrequency']").html(newVal);
                }
            }
        }
    };
    /**
     * Takes a value (number) and a unit (DAY/WEEK/MONTH/YEAR) checks for known conversions (like monthly) and translates it
     * @param value
     * @param unit
     * @param isFrequency if the unit should be converted to a frequency e.g. yearly instead of "1 YEAR"
     * @returns
     */
    RenderPricePreviewDataHandlers.prototype.formatValueWithUnit = function (value, unit, isFrequency) {
        if (isFrequency === void 0) { isFrequency = true; }
        if (!value || !unit) {
            console.warn('Tried formatting undefined unit for price preview');
            return '';
        }
        var val = value + ' ' + unit;
        //console.log("checking time mapping for '" + val + "' with mapping", this.timeMapping, this.timeMapping[val]);
        if (this.timeMapping[val] && isFrequency) {
            //console.log('using mapped interval', this.timeMapping[val]);
            return this.timeMapping[val];
        }
        else {
            //console.log('using unmapped interval', val);
            return value + ' ' + translation_1.default.t(value > 1 ? unit + 'S' : unit);
        }
    };
    RenderPricePreviewDataHandlers.prototype.findDiscountedOptionalModulePreview = function (module, voucherRes) {
        var _a, _b;
        return (_b = (_a = voucherRes === null || voucherRes === void 0 ? void 0 : voucherRes.data) === null || _a === void 0 ? void 0 : _a.selectedOptionalModulesPreviews) === null || _b === void 0 ? void 0 : _b.find(function (preview) { return preview.name === module.name && preview.discountedPrice !== null && preview.price !== preview.discountedPrice; });
    };
    RenderPricePreviewDataHandlers.prototype.findDiscountedFlatFeePreview = function (fee, voucherRes) {
        var _a, _b;
        return (_b = (_a = voucherRes === null || voucherRes === void 0 ? void 0 : voucherRes.data) === null || _a === void 0 ? void 0 : _a.flatFeePreviews) === null || _b === void 0 ? void 0 : _b.find(function (preview) { return preview.name === fee.name && preview.discountedPrice !== null && preview.price !== preview.discountedPrice; });
    };
    return RenderPricePreviewDataHandlers;
}());
exports.RenderPricePreviewDataHandlers = RenderPricePreviewDataHandlers;
function isTerm(input) {
    return typeof input.termValue === 'number';
}
function isFlatfee(input) {
    return typeof input.isStarterPackage === 'boolean';
}
function isOptionalModule(input) {
    return ((typeof input.paymentFrequencyValue === 'number' ||
        input.paymentFrequencyType === 'TERM_BASED' ||
        input.paymentFrequencyType === 'NON_RECURRING' ||
        input.paymentFrequencyType === 'FREE') &&
        !isTerm(input) &&
        !isFlatfee(input));
}
function clearVoucherPreview(preview) {
    if (!preview)
        return undefined;
    return __assign(__assign({}, preview), { discountValue: undefined, discountType: undefined, discountedBasePrice: undefined, discountedPreUseCharge: undefined, creditValue: undefined, effectivePeriodTimeBasedTerm: undefined, effectivePeriodTimeBasedTermUnit: undefined, flatFeePreviews: undefined, selectedOptionalModulesPreviews: undefined });
}
function isOffering(input) {
    return (typeof input.studioId === 'string' || typeof input.studioId === 'number') && Array.isArray(input.terms);
}
function adjustmentRuleIsAfterTerm(term) {
    var rules = term.priceAdjustmentRules;
    if (!rules || !(rules === null || rules === void 0 ? void 0 : rules.length))
        return { isAfterTerm: false };
    var rule = rules[0];
    var freq = rule.recurrenceFrequency;
    var newVal = rule.value;
    if (rule.type === 'NEW_BASIC_AMOUNT') {
        var priceMatch = newVal.match(/(\d{1,3},\d{2})\s?€/);
        var durationMatch = freq.match(/Nach\s+(\d+)\s+Monaten/);
        var price = priceMatch === null || priceMatch === void 0 ? void 0 : priceMatch[1]; // '34,95'
        var duration = durationMatch === null || durationMatch === void 0 ? void 0 : durationMatch[1]; // '12'
        if (price && duration && +duration <= term.termValue) {
            return { isAfterTerm: true, newPrice: +price.replace(',', '.') };
        }
    }
    return { isAfterTerm: false };
}
function getTermExtensionText(term) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    var newVal = '';
    if (term.extensionType === 'TERM_EXTENSION') {
        var adjustmentRuleEval = adjustmentRuleIsAfterTerm(term);
        var subPrice = void 0;
        if (adjustmentRuleEval.isAfterTerm) {
            subPrice = (_b = (_a = adjustmentRuleEval === null || adjustmentRuleEval === void 0 ? void 0 : adjustmentRuleEval.newPrice) === null || _a === void 0 ? void 0 : _a.toFixed(2)) !== null && _b !== void 0 ? _b : '';
        }
        else {
            subPrice = (_d = (_c = term.priceAfterExtension) === null || _c === void 0 ? void 0 : _c.toFixed(2)) !== null && _d !== void 0 ? _d : term.price.toFixed(2);
        }
        var subDuration = (0, time_mapping_const_1.formatValueWithUnit)((_e = term.termValueAfterExtension) !== null && _e !== void 0 ? _e : term.paymentFrequencyValue, (_f = term.termUnitAfterExtension) !== null && _f !== void 0 ? _f : term.paymentFrequencyUnit, true);
        var extension = (0, time_mapping_const_1.formatValueWithUnit)(term.extensionFixedTerm, term.extensionFixedTermUnit, false);
        newVal = "Um ".concat(extension, " zu je ").concat(subPrice, "\u20AC / ").concat(subDuration);
    }
    else if (term.extensionType === 'SUBSEQUENT_RATE_DETAIL') {
        var subDuration = (0, time_mapping_const_1.formatValueWithUnit)((_j = (_h = (_g = term.subsequentRateDto) === null || _g === void 0 ? void 0 : _g.terms) === null || _h === void 0 ? void 0 : _h[0]) === null || _j === void 0 ? void 0 : _j.paymentFrequencyValue, (_m = (_l = (_k = term.subsequentRateDto) === null || _k === void 0 ? void 0 : _k.terms) === null || _l === void 0 ? void 0 : _l[0]) === null || _m === void 0 ? void 0 : _m.paymentFrequencyUnit, true);
        var subPrice = ((_r = (_q = (_p = (_o = term.subsequentRateDto) === null || _o === void 0 ? void 0 : _o.terms) === null || _p === void 0 ? void 0 : _p[0]) === null || _q === void 0 ? void 0 : _q.price) === null || _r === void 0 ? void 0 : _r.toFixed(2)) || '';
        var extension = (0, time_mapping_const_1.formatValueWithUnit)((_s = term.subsequentRateDto) === null || _s === void 0 ? void 0 : _s.terms[0].termValue, (_t = term.subsequentRateDto) === null || _t === void 0 ? void 0 : _t.terms[0].termUnit, false);
        newVal = "Um ".concat(extension, " zu je ").concat(subPrice, "\u20AC / ").concat(subDuration);
    }
    else if (term.extensionType === 'NONE') {
        newVal = 'Keine';
    }
    return newVal;
}
